<template>
  <section class="section-description" :style="{ '--background-color': template.backgroundColor, '--text-color': template.textColor, '--highlight-color': template.highlightColor }">
    <div class="row" v-html="template.text">></div>
  </section>
</template>

<script>
export default {
  beforeMount() {
    this.template = this.$store.state.template.home.description;
  },
};
</script>

<style lang="scss">
.section-description {
  background-color: var(--background-color);
  color: var(--text-color);
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 11%;
  padding-right: 11%;

  @include media('<=tablet') {
    padding-top: 2%;
    padding-bottom: 5%;
    padding-left: 11%;
    padding-right: 11%;
  }
  strong {
    color: var(--highlight-color);
    color: #6f9ba8;
  }
  .row {
    max-width: 100%;
    margin: 0;
  }
  h4 {
    font-size: 2rem;
    font-weight: bold;
    color: #6f9ba8;
    margin-bottom: 20px;
  }

  p {
    font-size: 1.5rem;
    color: white;
    line-height: 1.23;
  }
}
</style>